<template>
  <div>
    <breadCrumbs title="Themify Icons" main="Icons" title1="Themify Icons" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" v-for="(item, index) in menu" :key="index">
          <div class="card">
            <div class="card-header pb-0">
              <h3 class="m-b-0">{{ item.name }}</h3>
            </div>
            <div class="card-body">
              <div class="row icon-lists">
                <div class="col-sm-6 col-md-6 col-lg-4" v-for="(index) in item.value" :key="index"
                  v-on:click="icon_bar(index)">
                  <i class="" :class="index"></i>{{ index }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="icon-hover-bottom p-fixed fa-fa-icon-show-div" :class="{ 'opecity-0': !icon_bar_status }"
      :style="[icon_bar_status ? { 'display': 'block' } : { 'display': 'none' }]">
      <div class="container-fluid">
        <div class="row">
          <div class="icon-popup">
            <div class="close-icon" v-on:click="close_icon_bar"><i class="icofont icofont-close"></i></div>
            <div class="icon-first"><i class="fa-2x" :class="[select_icon.class]"></i></div>
            <div class="icon-class">
              <label class="icon-title">Class</label><span>icon-drupal</span>
            </div>
            <div class="icon-last icon-last">
              <label class="icon-title">Markup</label>
              <div class="form-inline">
                <div class="form-group">
                  <input class="inp-val form-control m-r-10" type="text" ref="text" :value="select_icon.tag"
                    readonly="readonly">
                  <button class="btn btn-primary notification" v-on:click="copy_icon">Copy text</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import data from '@/data/themifyData.json'
export default {
  data() {
    return {
      icon_bar_status: false,
      select_icon: {
        class: '',
        tag: ''
      },
      menu: [
        { name: "Arrows & Direction Icons", value: data.directional },
        { name: "Web App Icons", value: data.webapp },
        { name: "Control Icons", value: data.control },
        { name: "Text Editor", value: data.texteditor },
        { name: "Brand Icons", value: data.brand },
      ],
    };
  },
  methods: {
    icon_bar(icon) {
      this.select_icon.class = icon;
      this.select_icon.tag = '<i class="' + icon + '"></i>';
      this.icon_bar_status = true;
    },
    close_icon_bar() {
      this.icon_bar_status = false;
    },
    copy_icon() {
      this.$refs.text.select();
      document.execCommand('copy');
      this.$toast.show('Code Copied to Clipboard', {
        theme: 'outline', position: 'bottom-right', closeOnSwipe: true, type: 'default', duration: 2000, className: 'alert-copy', action: {
          icon: 'times',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        }
      });
    }
  }
};
</script>